export const currencies = [
  { value: "USD", name: "United States Dollar", symbol: "$", label: "USD" },
  { value: "EUR", name: "Euro", symbol: "€", label: "EUR" },
  { value: "JPY", name: "Japanese Yen", symbol: "¥", label: "JPY" },
  { value: "GBP", name: "British Pound Sterling", symbol: "£", label: "GBP" },
  { value: "AUD", name: "Australian Dollar", symbol: "A$", label: "AUD" },
  { value: "CAD", name: "Canadian Dollar", symbol: "C$", label: "CAD" },
  { value: "CHF", name: "Swiss Franc", symbol: "CHF", label: "CHF" },
  { value: "CNY", name: "Chinese Yuan", symbol: "¥", label: "CNY" },
  { value: "SEK", name: "Swedish Krona", symbol: "kr", label: "SEK" },
  { value: "NZD", name: "New Zealand Dollar", symbol: "NZ$", label: "NZD" },
  { value: "MXN", name: "Mexican Peso", symbol: "MX$", label: "MXN" },
  { value: "SGD", name: "Singapore Dollar", symbol: "S$", label: "SGD" },
  { value: "HKD", name: "Hong Kong Dollar", symbol: "HK$", label: "HKD" },
  { value: "NOK", name: "Norwegian Krone", symbol: "kr", label: "NOK" },
  { value: "KRW", name: "South Korean Won", symbol: "₩", label: "KRW" },
  { value: "TRY", name: "Turkish Lira", symbol: "₺", label: "TRY" },
  { value: "RUB", name: "Russian Ruble", symbol: "₽", label: "RUB" },
  { value: "INR", name: "Indian Rupee", symbol: "₹", label: "INR" },
  { value: "BRL", name: "Brazilian Real", symbol: "R$", label: "BRL" },
  { value: "ZAR", name: "South African Rand", symbol: "R", label: "ZAR" },
  { value: "DKK", name: "Danish Krone", symbol: "kr", label: "DKK" },
  { value: "PLN", name: "Polish Zloty", symbol: "zł", label: "PLN" },
  { value: "TWD", name: "New Taiwan Dollar", symbol: "NT$", label: "TWD" },
  { value: "THB", name: "Thai Baht", symbol: "฿", label: "THB" },
  { value: "MYR", name: "Malaysian Ringgit", symbol: "RM", label: "MYR" },
  { value: "IDR", name: "Indonesian Rupiah", symbol: "Rp", label: "IDR" },
  { value: "CZK", name: "Czech Koruna", symbol: "Kč", label: "CZK" },
  { value: "HUF", name: "Hungarian Forint", symbol: "Ft", label: "HUF" },
  { value: "ILS", name: "Israeli New Shekel", symbol: "₪", label: "ILS" },
  { value: "PHP", name: "Philippine Peso", symbol: "₱", label: "PHP" },
  {
    value: "AED",
    name: "United Arab Emirates Dirham",
    symbol: "د.إ",
    label: "AED",
  },
  { value: "SAR", name: "Saudi Riyal", symbol: "﷼", label: "SAR" },
  { value: "QAR", name: "Qatari Riyal", symbol: "﷼", label: "QAR" },
  { value: "KWD", name: "Kuwaiti Dinar", symbol: "د.ك", label: "KWD" },
  { value: "BHD", name: "Bahraini Dinar", symbol: "ب.د", label: "BHD" },
  { value: "OMR", name: "Omani Rial", symbol: "ر.ع.", label: "OMR" },
  { value: "JOD", name: "Jordanian Dinar", symbol: "د.ا", label: "JOD" },
  { value: "EGP", name: "Egyptian Pound", symbol: "£", label: "EGP" },
  { value: "NGN", name: "Nigerian Naira", symbol: "₦", label: "NGN" },
  { value: "PKR", name: "Pakistani Rupee", symbol: "₨", label: "PKR" },
  { value: "BDT", name: "Bangladeshi Taka", symbol: "৳", label: "BDT" },
  { value: "LKR", name: "Sri Lankan Rupee", symbol: "Rs", label: "LKR" },
  { value: "MMK", name: "Myanmar Kyat", symbol: "K", label: "MMK" },
  { value: "VND", name: "Vietnamese Dong", symbol: "₫", label: "VND" },
  { value: "KHR", name: "Cambodian Riel", symbol: "៛", label: "KHR" },
  { value: "LAK", name: "Lao Kip", symbol: "₭", label: "LAK" },
  { value: "MNT", name: "Mongolian Tugrik", symbol: "₮", label: "MNT" },
  { value: "NPR", name: "Nepalese Rupee", symbol: "₨", label: "NPR" },
  { value: "BND", name: "Brunei Dollar", symbol: "B$", label: "BND" },
  { value: "FJD", name: "Fijian Dollar", symbol: "FJ$", label: "FJD" },
  { value: "PGK", name: "Papua New Guinean Kina", symbol: "K", label: "PGK" },
  { value: "SBD", name: "Solomon Islands Dollar", symbol: "SI$", label: "SBD" },
  { value: "TOP", name: "Tongan Paʻanga", symbol: "T$", label: "TOP" },
  { value: "VUV", name: "Vanuatu Vatu", symbol: "VT", label: "VUV" },
  { value: "WST", name: "Samoan Tala", symbol: "WS$", label: "WST" },
  { value: "XPF", name: "CFP Franc", symbol: "₣", label: "XPF" },
  { value: "XCD", name: "East Caribbean Dollar", symbol: "EC$", label: "XCD" },
  { value: "BBD", name: "Barbadian Dollar", symbol: "Bds$", label: "BBD" },
  { value: "BMD", name: "Bermudian Dollar", symbol: "BD$", label: "BMD" },
  { value: "BSD", name: "Bahamian Dollar", symbol: "B$", label: "BSD" },
  { value: "DOP", name: "Dominican Peso", symbol: "RD$", label: "DOP" },
  { value: "HTG", name: "Haitian Gourde", symbol: "G", label: "HTG" },
  { value: "JMD", name: "Jamaican Dollar", symbol: "J$", label: "JMD" },
  {
    value: "TTD",
    name: "Trinidad and Tobago Dollar",
    symbol: "TT$",
    label: "TTD",
  },
  { value: "BZD", name: "Belize Dollar", symbol: "BZ$", label: "BZD" },
  { value: "GTQ", name: "Guatemalan Quetzal", symbol: "Q", label: "GTQ" },
  { value: "HNL", name: "Honduran Lempira", symbol: "L", label: "HNL" },
  { value: "NIO", name: "Nicaraguan Córdoba", symbol: "C$", label: "NIO" },
  { value: "PAB", name: "Panamanian Balboa", symbol: "B/.", label: "PAB" },
  { value: "PYG", name: "Paraguayan Guarani", symbol: "₲", label: "PYG" },
  { value: "UYU", name: "Uruguayan Peso", symbol: "$U", label: "UYU" },
  { value: "VEF", name: "Venezuelan Bolívar", symbol: "Bs", label: "VEF" },
  { value: "BOB", name: "Bolivian Boliviano", symbol: "Bs.", label: "BOB" },
  { value: "CLP", name: "Chilean Peso", symbol: "$", label: "CLP" },
  { value: "COP", name: "Colombian Peso", symbol: "$", label: "COP" },
  { value: "PEN", name: "Peruvian Sol", symbol: "S/.", label: "PEN" },
  { value: "ARS", name: "Argentine Peso", symbol: "$", label: "ARS" },
  { value: "GHS", name: "Ghanaian Cedi", symbol: "GH₵", label: "GHS" },
  { value: "KES", name: "Kenyan Shilling", symbol: "KSh", label: "KES" },
  { value: "TZS", name: "Tanzanian Shilling", symbol: "TSh", label: "TZS" },
  { value: "UGX", name: "Ugandan Shilling", symbol: "USh", label: "UGX" },
  { value: "MAD", name: "Moroccan Dirham", symbol: "د.م.", label: "MAD" },
  { value: "DZD", name: "Algerian Dinar", symbol: "د.ج", label: "DZD" },
  { value: "TND", name: "Tunisian Dinar", symbol: "د.ت", label: "TND" },
  { value: "LYD", name: "Libyan Dinar", symbol: "ل.د", label: "LYD" },
  { value: "SDG", name: "Sudanese Pound", symbol: "ج.س.", label: "SDG" },
  { value: "ETB", name: "Ethiopian Birr", symbol: "Br", label: "ETB" },
  { value: "SOS", name: "Somali Shilling", symbol: "Sh", label: "SOS" },
  { value: "MGA", name: "Malagasy Ariary", symbol: "Ar", label: "MGA" },
  { value: "KZT", name: "Kazakhstani Tenge", symbol: "₸", label: "KZT" },
];
